import SiteMessagesInstance from '../../components/site-messages'
import supportedCsvDatapoints from '../../util/supported-csv-datapoints'

class AccountCsvSettings {

  constructor (container) {

    this.container = container;

    this.render();

    this.$checkboxes = $(this.container).find('input[type="checkbox"]');

    this.bindActions();

  }

  bindActions() {

    this.$checkboxes.on('change', () => {

      const datapoints = [];

      this.$checkboxes.each((i, checkbox) => {

        if($(checkbox).is(":checked")) {
          datapoints.push($(checkbox).val());
        }

      });

      apiRequest("post", "/user/csv_datapoints", {
        datapoints: datapoints,
      }).then(r => {
        if(r.type === 'error') {
          SiteMessagesInstance.addMessage("error", r.message);
          SiteMessagesInstance.displayMessages(true);
        }
      });

    });

  }

  render() {

    const columns = supportedCsvDatapoints;

    const html = `
    
    <p>Select which data points (if supported by your sensor) to include with your CSV downloads</p>
    
    ${columns.map(column => {
      return `
      <label class="account-csv-settings__include">
        <div class="account-csv-settings__include__checkbox">
          <input type="checkbox" value="${column.id}" name="csv_columns[]"
           ${window.currentUser && window.currentUser.csv_datapoints && window.currentUser.csv_datapoints.includes(column.id) ? 'checked' : ''}
           />
        </div>
        <div class="account-csv-settings__include__label">${column.name}</div>
      </label>
      `
    }).join('')}
    `;

    this.container.innerHTML = html;

  }

}

export default AccountCsvSettings;
